export function scrollToHeader(): void {
  const headerRef = document.getElementById('main-header');

  headerRef?.scrollIntoView({behavior: 'smooth'});
}
